<template>
    <div id="app" :class="['page-' + ($router.currentRoute.name ? ($router.currentRoute.name.toLowerCase()) : null), $router.currentRoute.meta.topClass ? 'top-' + $router.currentRoute.meta.topClass : '']">
        <div id="wrapper" class="">
            <!-- <div class="fixed-tabs">
                <ul>
                    <li>
                        <p>
                            Teste
                        </p>
                        <button>
                            <i class="las la-minus-circle"></i>
                        </button>
                    </li>
                </ul>
            </div> -->
            <!-- <router-view :key="$root.logged + '-' + $root.user.tipo + '-' + $route.fullPath"/> -->
            <router-view :key="$route.fullPath"/>

            <Chat v-show="showChatIcone()"/>
        </div>

        <div class="modal-teleconsulta" v-if="$root.modalTeleconsulta" v-bind:class="{'closed': $root.modalTeleconsulta == 'closed'}" >
            <div class="row" v-show="$root.modalTeleconsulta == 'closed'">
                <div class="col-xl-12">
                    <a class="float-right button small color-primary" v-on:click="$root.setModalTeleconsulta('opened')" v-if="$root.modalTeleconsulta == 'closed'">
                        <i class="las la-angle-up"></i> Mostrar teleconsulta
                    </a>
                </div>
            </div>
            <div class="row" v-show="$root.modalTeleconsulta == 'opened'">
                <div class="col-xl-12">
                    <h4 class="margin-bottom-15">
                        <i class="las la-info-circle"></i>
                        Informações da teleconsulta:

                        <a class="float-right button small gray" v-on:click="$root.setModalTeleconsulta('closed')" v-if="$root.modalTeleconsulta == 'opened'">
                            <i class="las la-angle-down"></i> Esconder
                        </a>
                    </h4>
                </div>
                <div class="col-xl-7">
                    <div class="submit-field padding-left-20">
                        <h4 v-if="$root.user.tipo == 'contratante'" class="margin-bottom-0">{{$root.teleconsulta.NM_PACIENTE}}</h4>
                        <h4 v-if="$root.user.tipo != 'contratante'" class="margin-bottom-0"><router-link :to="{'name': 'Paciente', 'query': {'CD_PESSOA_FISICA': $root.teleconsulta.CD_PESSOA_FISICA}}"><u>{{$root.teleconsulta.NM_PACIENTE}}</u></router-link></h4>
                        <small class="block margin-bottom-20" style="line-height: 150%; padding-left: 10px;">
                            - Atendimento: <b>{{$root.teleconsulta.NR_SEQUENCIA}}</b>
                            <br>- Código paciente: <b>{{$root.teleconsulta.CD_PESSOA_FISICA}}</b>
                            <br>- Responsável: <b>{{$root.teleconsulta.NM_MEDICO_AGENDA}}</b>
                            <br>- Especialidade: <b>{{$root.teleconsulta.DS_COMPLEMENTO}}</b>
                            <br>- Agendamento: <b>{{$root.teleconsulta.HR_INICIO | formatDateTime}}</b>
                            <br>- Situação:
                            <span class="dashboard-status-button color-orange" v-if="$root.teleconsulta.TELECONSULTA.objeto.status == 0">Pendente</span>
                            <span class="dashboard-status-button color-yellow" v-if="$root.teleconsulta.TELECONSULTA.objeto.status == 1">Aguardando paciente</span>
                            <span class="dashboard-status-button color-blue" v-if="$root.teleconsulta.TELECONSULTA.objeto.status == 2">Em consulta</span>
                            <span class="dashboard-status-button color-green" v-if="$root.teleconsulta.TELECONSULTA.objeto.status == 3">Realizada</span>
                        </small>
                    </div>
                </div>

                <div class="col-xl-5" style="text-align: right;">

                    <!-- <button class="button btn green margin-bottom-10 block-mobile" type="button" v-on:click="$root.iniciarChamada($root.teleconsulta.NR_SEQUENCIA)" v-if="(!$root.chamada || ($root.chamada ? $root.chamada.room != $root.teleconsulta.TELECONSULTANR_SEQUENCIA : false)) && $root.teleconsulta.TELECONSULTA.objeto.status == 0 && ($root.user.tipo == 'profissional' || $root.user.tipo == 'profissional-geral')">
                        <i class="las la-play-circle"></i>
                        Abrir videoconferência
                    </button>
                    <button class="button btn green margin-bottom-10 block-mobile" type="button" v-on:click="$root.iniciarChamada($root.teleconsulta.NR_SEQUENCIA)" v-if="(!$root.chamada || ($root.chamada ? $root.chamada.room != $root.teleconsulta.TELECONSULTANR_SEQUENCIA : false)) && $root.teleconsulta.TELECONSULTA.objeto.status == 1 && ($root.user.tipo == 'profissional' || $root.user.tipo == 'profissional-geral')">
                        <i class="las la-play-circle"></i>
                        Abrir videoconferência
                    </button>
                    <button class="button btn green margin-bottom-10 block-mobile" type="button" v-on:click="$root.iniciarChamada($root.teleconsulta.NR_SEQUENCIA)" v-if="(!$root.chamada || ($root.chamada ? $root.chamada.room != $root.teleconsulta.TELECONSULTANR_SEQUENCIA : false)) && $root.teleconsulta.TELECONSULTA.objeto.status == 2 && ($root.user.tipo == 'profissional' || $root.user.tipo == 'profissional-geral')">
                        <i class="las la-play-circle"></i>
                        Abrir videoconferência
                    </button>

                    <button class="button btn green margin-bottom-10 block-mobile" type="button" v-on:click="$root.iniciarChamada($root.teleconsulta.NR_SEQUENCIA)" v-if="(!$root.chamada || ($root.chamada ? $root.chamada.room != $root.teleconsulta.TELECONSULTANR_SEQUENCIA : false)) && $root.teleconsulta.TELECONSULTA.objeto.status == 1 && $root.user.tipo == 'contratante'">
                        <i class="las la-play-circle"></i>
                        Abrir videoconferência
                    </button>

                    <button class="button btn green margin-bottom-10 block-mobile" type="button" v-on:click="$root.iniciarChamada($root.teleconsulta.NR_SEQUENCIA)" v-if="(!$root.chamada || ($root.chamada ? $root.chamada.room != $root.teleconsulta.TELECONSULTANR_SEQUENCIA : false)) && $root.teleconsulta.TELECONSULTA.objeto.status == 2 && $root.user.tipo == 'contratante'">
                        <i class="las la-play-circle"></i>
                        Abrir videoconferência
                    </button>                                             -->

                    <button class="button btn color-orange margin-bottom-10 block-mobile" type="button" v-on:click="$root.finalizarChamada($root.teleconsulta.NR_SEQUENCIA)" v-if="$root.teleconsulta.TELECONSULTA.objeto.status == 2 && ($root.user.tipo == 'profissional' || $root.user.tipo == 'profissional-geral')">
                        <i class="las la-check-circle"></i>
                        Concluir consulta
                    </button>
                </div>
                <div class="col-xs-12" style="">

                    <div class="chamada-video" style="" v-if="!$root.cordova && $root.teleconsulta.TELECONSULTA.objeto.status < 3">
                        <div class="content" style="width: 100%;">
                            <div id="remote-media" v-show="$root.chamada"></div>
                            <div id="local-media" v-show="$root.chamada"></div>
                        </div>

                        <button v-show="$root.chamada" class="mute-audio" v-on:click="$root.muteAudio()">
                            <i class="las la-microphone-slash" v-show="!$root.chamadaMute.audio"></i>
                            <i class="las la-microphone" v-show="$root.chamadaMute.audio"></i>
                        </button>
                        <button v-show="$root.chamada" class="mute-video" v-on:click="$root.muteVideo()">
                            <i class="las la-video-slash" v-show="!$root.chamadaMute.video"></i>
                            <i class="las la-video" v-show="$root.chamadaMute.video"></i>
                        </button>
                    </div>
                </div>

                <div class="col-xl-12">

                </div>
            </div>
        </div>

        <div id="modal-agendar" class="modal">
            <div class="row agendar">
                <div class="col-lg-12" v-if="$root.modalAgendarData">
                    <div class="row">
                        <div class="col-xl-6 col-xs-12 col-md-12 col-lg-6">
                            <div class="header-image" :style="{'background-image': 'url(' + $root.modalAgendarData.detalhes.imagem + ')'}"></div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-xs-12 col-md-12">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="hidden-lg hidden-xl margin-top-20"></div>
                                    <h3 class="margin-bottom-0">{{$root.modalAgendarData.detalhes.nome}}</h3>
                                    <p class="margin-top-0 margin-bottom-5">
                                        {{$root.modalAgendarData.detalhes.descricao}}
                                    </p>
                                    <span class="dashboard-status-button gray">
                                        {{$root.modalAgendarData.detalhes.categorias}}
                                    </span>
                                </div>

                                <div class="col-xl-12">
                                    <p class="page-text margin-bottom-10 margin-top-20">
                                        Você tem certeza que deseja agendar a consulta de <b>{{$root.modalAgendarData.agendamento.DS_COMPLEMENTO}}</b> para <b>{{$root.modalAgendarData.agendamento.DT_AGENDA_EXT}}</b>?
                                    </p>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                <!-- <div class="col-xl-6 col-lg-6 col-xs-12 col-md-12"> -->
                                    <button type="button" class="button green block-mobile margin-bottom-10" onclick="window.__app.modalAgendarSubmit()">
                                        <i class="material-icons">check_circle</i>
                                        Enviar agendamento
                                    </button>
                                    <button type="button" class="button red block-mobile margin-bottom-10" style="" onclick="window.__app.back()">
                                        <i class="material-icons">close</i>
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="modal-termos-de-uso" class="modal">
            <div class="row" v-if="$root.config['termos-de-uso']">
                <div class="col-lg-12 margin-bottom-100">
                    <!-- Row -->
                    <div class="row">

                        <div class="col-xl-12">
                            <h3>Termos de uso</h3>
                        </div>

                        <div class="col-lg-12 col-xs-12 col-xl-12 v-html" v-html="$root.config['termos-de-uso'].conteudo">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="modal-politicas-de-privacidade" class="modal">
            <div class="row" v-if="$root.config['politicas-de-privacidade']">
                <div class="col-lg-12 margin-bottom-100">
                    <!-- Row -->
                    <div class="row">

                        <div class="col-xl-12">
                            <h3 class="">Políticas de privacidade</h3>
                        </div>

                        <div class="col-lg-12 col-xs-12 col-xl-12 v-html" v-html="$root.config['politicas-de-privacidade'].conteudo">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="modal-sintomas" class="modal modal-center">
            <div class="row xs-center center center-xs">
                <div class="col-lg-12">
                    <div class="row" v-for="(item, index) in $root.config.sintomas.itens" :key="item.cod" v-show="$root.sintomas.etapa == index">

                        <div class="col-xl-12">
                            <h3 class="">{{item.texto}}</h3>
                        </div>

                        <div class="col-xl-12" v-for="(item2, index2) in item.itens" :key="item2.cod">
                            <button type="button" class="button transparent margin-bottom-5 color-secondary" onclick="window.__app.enviarSintomas(this)" :data-index="index" :data-index2="index2">
                                {{item2.texto}}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import Top from './components/Top'
import BackButton from './components/BackButton'
import Chat from './components/Chat'
import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"

window.Toastify = Toastify;

export default {
    name: 'App',
    components: {
        'Top': Top,
        'Chat': Chat,
        'BackButton': BackButton,
    },
    filters: {
        formatDateTime: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
    },
    methods: {
        data () {
            var self                    = this;
            return {
                "modalAgendarData":     null,
            }
        },
        getConfig: function(force) {
            var self        = this;
            console.log("getConfig()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod,
                        "_token":       self.$root.user.token,
                        "multiplo":     true,
                        "nome":         "termos-de-uso,politicas-de-privacidade,menu"
                    }
                };

                axios.get("api/itens.php", form)
                .then(response => {

                    console.log("getConfig() response", response);
                    response.data.result.itens.forEach(function(item) {
                        self.$root.config[item.nome] = item.objeto;
                    });
                    setTimeout(function() {
                        self.$forceUpdate();
                        self.$root.$forceUpdate();
                    }, 100);
                    resolve(response.data.result);

                })
                .catch(error => {
                    console.log("getConfig() error", error);
                    reject(error);

                });
            });
        },
        showChatIcone() {
            var self = this;
            var show = true;
            // console.log("ESCONDER OPCOES GERAIS -> ", self.$root.config['opcoes-gerais'].esconderIconeChat);
            

            if (self.$root.config['opcoes-gerais'] && self.$root.config['opcoes-gerais'].esconderIconeChat == 1) {
                // console.log("CAIU NO ESCONDER GERAL");
                
                show = false;
            } else {
                if (self.$route.name) {
                    if (self.$root.checkPermissao(self.$route.name, 'hideChatBubble')) {
                        show = false;
                        // console.log("showChatIcone: Caiu no check de hideChatBubble");
                    } else {
                        if (self.$root.logged) {
                            if (self.$root.user.tipo == 'admin' || self.$root.user.tipo == 'profissional' || self.$root.user.tipo == 'profissional-geral') {
                                if (self.$router.currentRoute ? (!['Painel'].includes(self.$router.currentRoute.name)) : true) {
                                    show = true;
                                }
                            }
                        }
                    }
                }
            }

            console.log("showChatIcone: ", show);
            return show;
        }
    },
    mounted: function() {
        console.log("app mounted >");
        var self = this;
        setTimeout(function() {
            // self.getConfig();
        }, 200)
    }
}
</script>

<style>

    #remote-media {
        width: 100%;
        text-align: center;
        height: 31vh;
        /* height: 100%; */
    }

    #remote-media video {
        width: auto !important;
        /* height: 100% !important;         */
        /* height: 80vh !important;         */
        height: auto;
        max-height: 30vh !important;
        /*width: auto;*/
        /* margin-top: 6px; */
    }

    #local-media {
        display: flex;
        position: absolute;
        right: 10px;
        bottom: 10px;
        width: 100px;
        height: 100px;
        background: #000;
        /*border: 1px solid #ddd;*/
    }

    #local-media video {
        width: 100%;
    }

    .chamada-video {
        display: flex;
        align-items: center;
        background-color: #ddd;
        /* height: 80vh;    */
        height: 100%;
        position: relative;
        /*background-image: url(static/images/video-placeholder.png);*/
        /*background-size: 80%;*/
        /*background-position: center;*/
        /*background-repeat: no-repeat;*/
    }

    .chamada-video .placeholder {
        width: 100%;
        opacity: 0.1;
    }

    .chamada-video p {
        text-align: center;
        color: #fff;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
        position: absolute;
    }


    .mute-audio {
        position: absolute;
        bottom: 10px;
        left: 10px;
        background: var(--theme-color-primary);
        border: 2px solid #ddd;
        border-radius: 50%;
        height: 50px;
        width: 50px;
    }
    .mute-audio i {
        font-size: 30px;
        color: #fff;
        position: relative;
        top: 2px;
    }

    .mute-video {
        position: absolute;
        bottom: 10px;
        left: 70px;
        background: var(--theme-color-primary);
        border: 2px solid #ddd;
        border-radius: 50%;
        height: 50px;
        width: 50px;
    }
    .mute-video i {
        font-size: 30px;
        color: #fff;
        position: relative;
        top: 2px;
    }


    @media only screen and (max-width: 500px) {
        .modal-teleconsulta:not(.closed) {
            width: auto;
            left: 10px;
            right: 10px;
        }
    }

    .modal-teleconsulta span.dashboard-status-button {
        font-size: 12px !important;
        line-height: 14px;
        margin-left: 6px;
    }

    .modal-teleconsulta {
        position: fixed;
        bottom: 10px;
        top: auto;
        right: 10px;
        /* width: auto; */
        /* height: auto; */
        width: 500px;
        height: 60vh;
        background: #fff;
        z-index: 99999;
        padding: 10px;
        border: 1px solid #ddd;
        box-shadow: 0 2px 100px rgb(0 0 0 / 42%) !important;
        border-radius: 20px;
        cursor: move;
    }

    .modal-teleconsulta .button.color-orange {
        padding: 10px;
        font-size: 16px;
    }

    .modal-teleconsulta h4 {
        font-size: 18px !important;
    }

    .modal-teleconsulta.closed {
        width: auto;
        min-width: 215px !important;
        height: 58px !important;
        bottom: 10px !important;
        top: auto !important;
        left: auto !important;
    }

    #app {


    }
</style>



// WEBPACK FOOTER //
// src/App.vue